import React, { Fragment, useState } from "react";
import moment from 'moment';
import {
    Row,
    DropdownToggle, Button, Card
} from 'reactstrap';
import ReactTable from 'react-table';
import no_invitations from '../../../../../../assets/no_invitations.png';
import DataTablePagination from '../../../../../../components/DatatablePagination';
import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import ShowVoucher from "./ShowVoucher";
import ShowHistory from "./ShowHistory";
const ShowInvitations = ({ invitationData }) => {
    const [data, setData] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showVoucher, setShowVoucher] = useState(false);
    const dataTableColumns = [
        {
            Header: 'Sender Name',
            accessor: 'senderName',
            Cell: props => <p style={{ marginLeft: "10%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Sender Email',
            accessor: 'senderEmail',
            Cell: props => <p style={{ marginLeft: "12%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Invitee Name',
            accessor: 'inviteeName',
            Cell: props => <p style={{ marginLeft: "12%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },

        {
            Header: 'Invitee Email',
            accessor: 'inviteeEmail',
            Cell: props => <p style={{ marginLeft: "12%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Processing Fee',
            accessor: 'processingFee',
            Cell: props => <p style={{ marginLeft: "12%" }} > {props.value} %</p>,
            style: { 'whiteSpace': 'unset' }
        },
        // {
        //     Header: 'Sell Future Vouchers',
        //     accessor: 'sellFutureVouchers',
        //     Cell: props => <p style={{ marginLeft: "12%" }} > {props.value ? "True" : "False"}</p>,
        //     style: { 'whiteSpace': 'unset' }
        // },
        {
            Header: 'Created Date',
            accessor: 'createdDate',
            Cell: props => <p style={{ marginLeft: "10%" }} >{moment(props.value).format("DD-MM-YYYY hh:mm:ss A")}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: '',
            accessor: 'invitationId',
            Cell: props => <p style={{ marginLeft: "10%" }} > <Button color="primary" size="xs" onClick={() => handleVoucher(props.value)}>Vouchers</Button> </p>,

            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: '',
            accessor: 'invitationId',
            Cell: props => <p style={{ marginLeft: "10%" }} > <Button color="primary" size="xs" onClick={() => handleHistory(props.value)}>History</Button> </p>,
            style: { 'whiteSpace': 'unset' }
        },

    ];
    const handleVoucher = (id) => {
        invitationData.map((m) => {
            if (m.invitationId === id) {
                setData(m.connectedVoucher);
            }
        });
        setShowVoucher(true);
    };
    const handleHistory = (id) => {
        invitationData.map((m) => {
            if (m.invitationId === id) {
                setData(m.invitationHistory);
            }
        });
        setShowPopup(true);
    }
    return (
        <Fragment>
            <Row className="col-md-12">
                <Colxx xxs="12">
                    <Card className="d
        -flex flex-row mb-3">
                        <Fragment>
                            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                {invitationData && invitationData.length > 0 ? (
                                    <ReactTable
                                        data={invitationData}
                                        columns={dataTableColumns}
                                        defaultPageSize={10}
                                        filterable={false}
                                        showPageJump={true}
                                        PaginationComponent={DataTablePagination}
                                        showPageSizeOptions={true}
                                        className="-striped -highlight -bordered"

                                        style={{ width: "100%" }}
                                    />
                                ) : ""
                                }
                            </div>
                        </Fragment>
                    </Card>
                </Colxx>
            </Row>
            {showPopup && <ShowHistory isOpen={showPopup} toggle={() => setShowPopup(!showPopup)} HistoryData={data}></ShowHistory>}
            {showVoucher && <ShowVoucher isOpen={showVoucher} toggle={() => setShowVoucher(!showVoucher)} HistoryData={data}></ShowVoucher>}
        </Fragment>
    );
}
export default ShowInvitations;